var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2667_1441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8535 6.8535L6.707 8L7.8535 9.1465C8.049 9.342 8.049 9.658 7.8535 9.8535C7.756 9.951 7.628 10 7.5 10C7.372 10 7.244 9.951 7.1465 9.8535L6 8.707L4.8535 9.8535C4.756 9.951 4.628 10 4.5 10C4.372 10 4.244 9.951 4.1465 9.8535C3.951 9.658 3.951 9.342 4.1465 9.1465L5.293 8L4.1465 6.8535C3.951 6.658 3.951 6.342 4.1465 6.1465C4.342 5.951 4.658 5.951 4.8535 6.1465L6 7.293L7.1465 6.1465C7.342 5.951 7.658 5.951 7.8535 6.1465C8.049 6.342 8.049 6.658 7.8535 6.8535ZM12 3.5V9.5C12 10.8785 10.8785 12 9.5 12H2.5C1.1215 12 0 10.8785 0 9.5V3.5C0 2.1215 1.1215 1 2.5 1H3V0.5C3 0.2235 3.224 0 3.5 0C3.776 0 4 0.2235 4 0.5V1H8V0.5C8 0.2235 8.224 0 8.5 0C8.776 0 9 0.2235 9 0.5V1H9.5C10.8785 1 12 2.1215 12 3.5ZM1 3.5V4H11V3.5C11 2.673 10.327 2 9.5 2H2.5C1.673 2 1 2.673 1 3.5ZM11 9.5V5H1V9.5C1 10.327 1.673 11 2.5 11H9.5C10.327 11 11 10.327 11 9.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2667_1441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/calendar-2.5b007ed5aaf65de6a780422cf31c11ab.svg";
export { ForwardRef as ReactComponent };